import type { ReduxModuleDefinition } from '@exodus/redux-dependency-injection';

import id from './id.js';
import initialState from './initial-state.js';
import { ACTIONS_EVENT, APPS_EVENT } from '../constants.js';
import selectorDefinitions from './selectors/index.js';

const blinksReduxDefinition = {
  id,
  type: 'redux-module',
  initialState,
  eventReducers: {
    [ACTIONS_EVENT]: (state, payload) => {
      return {
        ...state,
        data: {
          ...state.data,
          actions: payload,
        },
      };
    },
    [APPS_EVENT]: (state, payload) => {
      return {
        ...state,
        loaded: true,
        data: {
          ...state.data,
          apps: payload,
        },
      };
    },
  },
  selectorDefinitions,
} as const satisfies ReduxModuleDefinition;

export default blinksReduxDefinition;
